import { DatePicker, Layout, Tooltip } from "antd";
import FormItem from "antd/lib/form/FormItem";
import React, { useContext } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { NaocDailyProductionForm } from "./NaocDailyProductionForm";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
const { Content } = Layout;
export const ManualFormEntry = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Layout
      style={{
        background: "#fff",
        marginTop: "20px",
      }}
    >
      <Content
        className="ms-depth8"
        style={{
          background: "#F0F2F5",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <SubPageHeaderTitle title="Daily Production Entry  Pane" />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <FormItem
              label={
                <span style={{ color: "red" }}>Production Refer Date *</span>
              }
            >
              <Tooltip title="NAOC JV operations daily flash production date">
                <DatePicker
                  value={toAntPickerDate(naocDailyProductionStore?.uploadDate)}
                  onChange={(date, dateString) => {
                    console.log(date, dateString);
                    naocDailyProductionStore.uploadDate = dateString;
                    naocDailyProductionStore.initFormaData.productionDate =
                      getPickerDate(date);
                  }}
                  style={{ width: "100%" }}
                  defaultValue={toAntPickerDate(new Date())}
                  format={"DD-MMM-YYYY"}
                />
              </Tooltip>
            </FormItem>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <NaocDailyProductionForm />
          </div>
        </div>
      </Content>
    </Layout>
  );
});

